import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-controllo-errori-visibilita-prodotti',
	templateUrl: './controllo-errori-visibilita-prodotti.component.html',
})
export class ControlloErroriVisibilitaProdottiComponent implements OnInit {
	clienti: any[] = [];
	payloadVisibilitaProdotti: any = {};

	constructor(private api: ApiService) {}

	ngOnInit(): void {
		this.api.getClienti().subscribe((clienti) => (this.clienti = clienti));
	}

	controlloVisibilita() {
		this.api.checkProdottoVisibile(this.payloadVisibilitaProdotti).subscribe((res) => alert(res));
	}
}
